import { useState } from "react";
import { Button } from "react-bootstrap";
import Loading from "./Loading";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../css/OrderSummary.css";
import axiosInstance from "../api/axiosConfig";

export default function OrderSummary({ shipping, customerData, paymentMethod }) {
  const accessToken = useSelector((state) => state.customer.token);
  console.log(paymentMethod);
  const orderContent = useSelector((state) => state.shoppingCart.content);
  const [spinner, setSpinner] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeOrder = async () => {
    const response = await axiosInstance({
      method: "patch",
      url: `/orders/place-order`,
      headers: { Authorization: `Bearer ${accessToken}` },
      data: {
        shippingDetails: shipping,
        paymentMethod: paymentMethod,
      },
    });
  };

  const handleSpinner = () => {
    dispatch({ type: "CLEAR_CART" });
    setSpinner(true);
    storeOrder();
    setTimeout(() => {
      setSpinner(false);
      navigate("/thankyou");
    }, 4000);
  };
  if (spinner) {
    return <Loading />;
  }
  return (
    <div className="mt-5 mb-5">
      <h2>Summary</h2>
      <table className="table">
        <tr className="summaryHeader">
          <th className="">Billing Details</th>
          <th></th>
          <th></th>
        </tr>
        <>
          <tr>
            <td className="">
              <strong>First Name:</strong> {customerData.firstname}
            </td>
            <td className="pe-3">
              <strong>Last Name:</strong> {customerData.lastname}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Phone Number:</strong>
              {customerData.phoneNumber}
            </td>
            <td>
              <strong>Address :</strong> {customerData.address}
            </td>
          </tr>
        </>
        <tr className="summaryHeader">
          <th className="">Shipping Details</th>
          <th></th>
          <th></th>
        </tr>
        <>
          <tr>
            <td className="">
              <strong>First Name:</strong> {shipping.firstname}
            </td>
            <td className="pe-3">
              <strong>Last Name:</strong> {shipping.lastname}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Phone Number:</strong>
              {shipping.phoneNumber}
            </td>
            <td>
              <strong>Address:</strong> {shipping.address}
            </td>
            <td>
              <strong>Payment method:</strong> {paymentMethod}
            </td>
          </tr>
        </>
        <tr className="summaryHeader">
          <th className="">Product</th>
          <th className="pe-3 text-center">Quantity</th>
          <th className="text-center">Total</th>
        </tr>
        {orderContent.map((product) => (
          <tr key={product.id}>
            <td className="">{product.name}</td>
            <td className="pe-3 text-center">{product.quantity}</td>
            <td className="text-center">
              U$S {(product.quantity * product.sellingPrice).toFixed(2)}
            </td>
          </tr>
        ))}
        <tr>
          <td className="fw-bold">TOTAL:</td>
          <td></td>
          <td className="fw-bold text-center">
            U$S{" "}
            {orderContent
              .reduce(
                (previousTotal, product) => previousTotal + product.quantity * product.sellingPrice,
                0,
              )
              .toFixed(2)}
          </td>
        </tr>
      </table>
      <Button
        onClick={handleSpinner}
        className="rounded-pill btn-main border p-2 text-center confirm-button"
      >
        Place Order
      </Button>
    </div>
  );
}
